import { UUID } from "../../basetypes";
import { DeliveryRules } from "./deliveryrules";
import { SaleQuestionnaire, UnfilledQuestionnaireResult } from "./salequestionnaire";
import { Ticket } from "./ticket";

export type Cart = {
    Items: CartItem[];
    UnfilledQuestionnaireResult: UnfilledQuestionnaireResult[];
    HaveUnfilledQuestionnaireByCart: boolean;
    HasCartSaleQuestionaireDefinition: boolean;
    IsCartEmpty: boolean;
    TotalQuantity: number;
    TotalPrice: number;
    TotalServiceFees: number;
    TotalShippingFees: number;
    TotalFeesAndShippingFees: number;
    Total: number;
    TotalWithoutPrepaidCardAmount: number;
    CurrencyCode: string;
    ModelID: string;
    IsReadonly: boolean;
    ParentModelID: string;
    ParentPropertyName: string;
    ListName: string;
    IsNewModel: boolean;
    SelfCheckForModification: boolean;
}

export enum CartItemType
{
    Event = 0,
    Package = 1
}

export enum ProductType {
    Ticket = 0,
    PrepaidCard = 1,
    MembershipCard = 2,
    Product = 3,
    Donation = 4
}

export type CartItem = {
    ID: UUID;
    SaleQuestionnaire: SaleQuestionnaire;
    DeliveryRules: DeliveryRules;
    Tickets: Ticket[];
    ProductType: ProductType;
    SubProducts: CartItem[]; // To be defined
    Type: CartItemType;
    NameWithEventDate: string;
    EventDateID: number;
    EventID: number;
    PackageID: number;
    ProducerID: number;
    ProducerName: string;
    OwnerPOSID: number;
    Name: string;
    EventDate: string;
    Date: number;
    PhysicalVenueName: string;
    VenueName: string;
    Description: string;
    IsMailDelivery: boolean;
    IsEticketDelivery: boolean;
    DeliveryMethodSet: boolean;
    Price: number;
    ServiceFees: number;
    ShippingFees: number;
    ShippingFeeID: string;
    Quantity: number;
    DateToBeDeterminated: boolean;
    IsGuestClientAuthorized: boolean;
    ShowOnlyWholePricesOnInternet: boolean;
    EventDateCode: string;
    EventCategory: string;
    EventCategoryFr: string;
    EventCategoryEn: string;
}
